import { render } from "./AsHeaderMobile.vue?vue&type=template&id=4998a973&scoped=true&ts=true"
import script from "./AsHeaderMobile.vue?vue&type=script&lang=ts"
export * from "./AsHeaderMobile.vue?vue&type=script&lang=ts"

import "./AsHeaderMobile.vue?vue&type=style&index=0&id=4998a973&lang=scss"
import "./AsHeaderMobile.vue?vue&type=style&index=1&id=4998a973&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4998a973"]])

export default __exports__